import { render, staticRenderFns } from "./CurrentSelectionList.vue?vue&type=template&id=bdb8256e&scoped=true"
import script from "./CurrentSelectionList.vue?vue&type=script&lang=js"
export * from "./CurrentSelectionList.vue?vue&type=script&lang=js"
import style0 from "./CurrentSelectionList.vue?vue&type=style&index=0&id=bdb8256e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb8256e",
  null
  
)

export default component.exports